/**
 * Returns true if there are devices of a specific type or on native platform.
 *
 * @param {Object} state - The state of the application.
 * @param {string} type - The type of device: VideoOutput | audioOutput | audioInput.
 *
 * @returns {boolean}
 */
export function hasAvailableDevices(state, type) {
    var _a;
    if (state['features/base/devices'] === undefined) {
        return true;
    }
    const availableDevices = state['features/base/devices'].availableDevices;
    return Number((_a = availableDevices[type]) === null || _a === void 0 ? void 0 : _a.length) > 0;
}
